import React from 'react'
import { GridFeeState, GridFeeStateType } from 'src/Libs/dynamic-tariff-settings/dto/dynamic-tariff-settings.dto'
import { useFormContext } from 'react-hook-form'
import { TabButtonGroup } from 'src/Libs/inputs/react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DynamicTariffSettingsFormFields } from 'src/Libs/dynamic-tariff-settings/constants'

interface Option {
  label: string
  value: GridFeeStateType
}

interface Props {
  disabled: boolean
}

/**
 * component to select grid fee state for dynamic tariff settings
 */
const GridFeeStateButtonGroup: React.FC<Props> = ({ disabled }) => {
  const { setValue, clearErrors } = useFormContext()
  const { t } = useCustomTranslation()

  const options: Option[] = [
    { label: t('dynamic-tariff-settings.grid-fee-state.included'), value: GridFeeState.Included },
    { label: t('dynamic-tariff-settings.grid-fee-state.static'), value: GridFeeState.Static },
    { label: t('dynamic-tariff-settings.grid-fee-state.variable'), value: GridFeeState.Variable },
  ]

  const handleGridFeeStateChange = (newState: GridFeeStateType): void => {
    setValue(DynamicTariffSettingsFormFields.GridFeeState, newState)
    clearErrors(DynamicTariffSettingsFormFields.GridFees)

    /* Set default values for 'gridFees' based on grid fee state */
    switch (newState) {
      case GridFeeState.Variable:
        setValue(DynamicTariffSettingsFormFields.GridFees, [], { shouldDirty: true })
        break
      case GridFeeState.Static:
        setValue(DynamicTariffSettingsFormFields.GridFees, 0, { shouldDirty: true })
        break
      default:
        /* 'GridFeeState.Dynamic' */
        setValue(DynamicTariffSettingsFormFields.GridFees, null, { shouldDirty: true })
    }
  }

  const onChange = (value: string | number | boolean): void => {
    handleGridFeeStateChange(value as GridFeeStateType)
  }

  const suffixComponent = (
    <TabButtonGroup disabled={disabled} name={DynamicTariffSettingsFormFields.GridFeeState} options={options} onChange={onChange} />
  )

  return (
    <SettingsBox
      title={t('dynamic-tariff-settings.grid-fee-state.title')}
      description={t('dynamic-tariff-settings.grid-fee-state.description')}
      suffix={suffixComponent}
      disabled={disabled}
    />
  )
}

export default GridFeeStateButtonGroup
